export const gridCSS = {
    activeButton: {
        background: "#4297d3",
        color: "#ffffff",
        fontSize: "12px",
        border: "none",
        outline: "0px",
        cursor: "pointer",
        borderRadius: "3px",
        padding: "2px 3px",
    },
    inActiveButton: {
        background: "#ffffff",
        color: "#6d7888",
        fontSize: "12px",
        cursor: "pointer",
        border: "none",
        outline: "0px",
        padding: "2px 3px",
    },
    tabContainer: {
        padding: "15px",
        height: "95vh",
    },
    grid: {
        background: "#F8F8F8",
        padding: "10px 0px",
        borderRadius: "10px",
        margin: "0 !important",
        width: "100% !important",
    },
    head: {
        color: "#0071DC",
        fontSize: "12px",
        fontWeight: 600,
        font: "normal normal 600 12px/16px Segoe UI",
        marginBottom: "8px",
    },
    text: {
        color: "#3B3A39",
        fontSize: "12px",
        font: "normal normal 600 12px/16px Segoe UI",
    },
};